var _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDvdPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 14.9348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Blue-ray Player") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8115,3.3171c-1.3371,0-2.421,1.084-2.421,2.4211s1.0839,2.4211,2.421,2.4211,2.421-1.0838,2.421-2.4211-1.084-2.4211-2.421-2.4211ZM11.8115,7.6088c-1.0331,0-1.8706-.8376-1.8706-1.8706s.8375-1.8706,1.8706-1.8706,1.8706.8376,1.8706,1.8706-.8376,1.8706-1.8706,1.8706Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1958,12.8264c0-.3981-.3241-.7222-.7222-.7222s-.7223.3241-.7223.7222.3241.7222.7223.7222.7222-.3241.7222-.7222ZM19.1063,12.8295c0-.2068.1698-.3766.3765-.3766s.3765.1698.3765.3766-.1698.3766-.3765.3766-.3765-.1698-.3765-.3766Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.23,12.8264c0-.3981-.3241-.7222-.7222-.7222s-.7223.3241-.7223.7222.3241.7222.7223.7222.7222-.3241.7222-.7222ZM21.1405,12.8295c0-.2068.1698-.3766.3765-.3766s.3765.1698.3765.3766-.1698.3766-.3765.3766-.3765-.1698-.3765-.3766Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.0009,
    y: 10.1511,
    width: 0.8429,
    height: 1.3353,
    rx: 0.4025,
    ry: 0.4025
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9427,
    y: 10.1511,
    width: 0.8429,
    height: 1.3353,
    rx: 0.4025,
    ry: 0.4025
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8845,
    y: 10.1511,
    width: 0.8429,
    height: 1.3353,
    rx: 0.4025,
    ry: 0.4025
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5543,11.1375h-.5239c-.1093,0-.1979.0962-.1979.215v1.2303c0,.1186.0886.2149.1979.2149h13.9948c.1093,0,.1979-.0964.1979-.215v-1.2303c0-.1188-.0886-.215-.1979-.215h-.6173M15.7422,11.9821c0,.0321-.0239.0581-.0534.0581H2.4726c-.0295,0-.0534-.026-.0534-.0581v-.4477c0-.0321.0239-.0581.0534-.0581h13.2162c.0295,0,.0534.026.0534.0581v.4477h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.78,9.0395h-6.2799c.659-.9342,1.0496-2.0712,1.0496-3.3013,0-3.1691-2.569-5.7382-5.7381-5.7382s-5.7381,2.5691-5.7381,5.7382c0,1.2301.3906,2.3671,1.0496,3.3013H1.2201c-.6738,0-1.2201.5446-1.2201,1.2162v3.4237c0,.6717.5463,1.2162,1.2201,1.2162h21.5599c.6738,0,1.22-.5446,1.22-1.2162v-3.4237c0-.6717-.5463-1.2162-1.22-1.2162ZM6.6119,5.7382c0-2.8716,2.3279-5.1995,5.1996-5.1995s5.1995,2.3278,5.1995,5.1995c0,1.2537-.4439,2.4034-1.1827,3.3013H7.7946c-.7388-.8979-1.1827-2.0477-1.1827-3.3013ZM23.462,13.5443c0,.4272-.3475.7736-.7761.7736H1.3546c-.4285,0-.776-.3463-.776-.7736v-3.1566c0-.4272.3474-.7736.776-.7736h21.3314c.4286,0,.7761.3464.7761.7736v3.1566h-.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvdPlayer);
export default __webpack_public_path__ + "static/media/dvd-player.4578dd524e0240caa845c8767f76c3e2.svg";
export { ForwardRef as ReactComponent };